import React, { FC } from "react"
import { Props } from "./types"
import * as styles from "./styles.module.scss"
import Img from "gatsby-image"
import ArrowLink from "src/components/ArrowLink"
import { usePages } from "src/context/pages"

const ListTaskTeam: FC<Props> = ({
  className = "",
  title,
  description,
  image,
  imageTitle,
  bgImage,
  list,
  buttonText,
}) => {
  const { getPage } = usePages()
  return (
    <div className={`${className} ${styles.tasks} content-wrapper`}>
      <div className={styles.imageContainer}>
        <div className={styles.bg}>
          <Img
            fluid={bgImage.childImageSharp.fluid}
            style={{ height: "100%", width: "100%" }}
          />
        </div>
        <h3 className={styles.imageTitle}>{imageTitle}</h3>
        {image && (
          <div className={styles.image}>
            <Img
              fluid={image.childImageSharp.fluid}
              style={{ height: "100%", width: "100%" }}
            />
          </div>
        )}
      </div>

      <div className={`${styles.tasksContainer} content-wrapper`}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
        <div className={styles.grid}>
          {list.map(task => (
            <div className={styles.card} key={task.title}>
              <h3 className={styles.cardTitle}>{task.title}</h3>
              <p className={styles.cardDescription}>{task.description}</p>
            </div>
          ))}
        </div>
        <ArrowLink
          text={buttonText}
          to={getPage("features").url}
          className={`button-new button-new--primary ${styles.button}`}
        />
      </div>
    </div>
  )
}

export default ListTaskTeam
